import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {MatTooltip} from '@angular/material/tooltip';

@Directive({
    selector: '[appTruncatedTooltip]',
    providers: [MatTooltip],
    host: {
        '(mouseenter)': 'checkForOverflow()',
        '(mouseleave)': 'hide()'
    },

})
export class TruncatedTooltipDirective implements AfterViewInit {
    @Input('appTruncatedTooltip') tooltipText: string = '';

    constructor(
        private el: ElementRef,
        private tooltip: MatTooltip,
    ) {
    }

    ngAfterViewInit(): void {
        this.checkForOverflow();
    }

    checkForOverflow(): void {
        const element = this.el.nativeElement;
        const isTruncated: boolean = element.scrollWidth > element.clientWidth;

        if (isTruncated) {
            this.tooltip.message = this.tooltipText || element.innerText;
            this.tooltip.show();
        } else {
            this.tooltip.hide();
        }
    }

    hide(): void {
        this.tooltip.hide();
    }
}
